/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CurrentOwnerUpdateRequest,
  PutApiCurrentOwnerUpdate200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type putApiCurrentOwnerUpdateResponse200 = {
  data: PutApiCurrentOwnerUpdate200
  status: 200
}

export type putApiCurrentOwnerUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiCurrentOwnerUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiCurrentOwnerUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiCurrentOwnerUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiCurrentOwnerUpdateResponseSuccess = (putApiCurrentOwnerUpdateResponse200) & {
  headers: Headers;
};
export type putApiCurrentOwnerUpdateResponseError = (putApiCurrentOwnerUpdateResponse400 | putApiCurrentOwnerUpdateResponse401 | putApiCurrentOwnerUpdateResponse403 | putApiCurrentOwnerUpdateResponse409) & {
  headers: Headers;
};

export type putApiCurrentOwnerUpdateResponse = (putApiCurrentOwnerUpdateResponseSuccess | putApiCurrentOwnerUpdateResponseError)

export const getPutApiCurrentOwnerUpdateUrl = () => {


  

  return `/api/owner`
}

export const putApiCurrentOwnerUpdate = async (currentOwnerUpdateRequest: CurrentOwnerUpdateRequest, options?: RequestInit): Promise<putApiCurrentOwnerUpdateResponse> => {
  
  return customFetch<putApiCurrentOwnerUpdateResponse>(getPutApiCurrentOwnerUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currentOwnerUpdateRequest,)
  }
);}


